// Grant XP + NX panel — used inside the Users tab profile modal.
import { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

export function GrantPanel({ uid, onDone }) {
  const [xp, setXp] = useState(100);
  const [coins, setCoins] = useState(50);
  const [reason, setReason] = useState("");
  const grant = async () => {
    try {
      await api.post("/owner/grant", { user_id: uid, xp: parseInt(xp), coins: parseFloat(coins), reason });
      toast.success(`Granted +${xp} XP · +${coins} NX`); onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Grant failed"); }
  };
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="grant-panel">
      <div><div className="label-eyebrow mb-1">xp</div><input type="number" value={xp} onChange={(e) => setXp(e.target.value)} className="w-full bg-transparent border border-white/10 px-2 py-1.5 text-xs" data-testid="grant-xp" /></div>
      <div><div className="label-eyebrow mb-1">NX</div><input type="number" value={coins} onChange={(e) => setCoins(e.target.value)} className="w-full bg-transparent border border-white/10 px-2 py-1.5 text-xs" data-testid="grant-coins" /></div>
      <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (optional)" className="col-span-2 bg-transparent border border-white/10 px-2 py-1.5 text-xs" />
      <button onClick={grant} className="btn-nexus col-span-2 justify-center" data-testid="grant-fire">Grant</button>
    </div>
  );
}
